import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT_INFO, BRAND_TAGLINE } from "@/data/site";

const Footer = () => {
  return (
    <footer className="relative border-t border-white/5" data-testid="site-footer" style={{ background: "#0F1437" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid lg:grid-cols-2 gap-10 items-start">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="logo-card-back" aria-hidden="true" />
              <span className="font-serif-display text-2xl text-white">
                Verna Carr
                <span className="block text-[0.65rem] tracking-[0.25em] uppercase font-body mt-0.5" style={{ color: "var(--cs-cyan)" }}>
                  Tarot Readings
                </span>
              </span>
            </div>
            <p className="text-sm text-slate-200 leading-relaxed max-w-md mb-6">
              Personal tarot readings with 35 years of intuitive practice — based in Whitianga, New Zealand. In person, by phone, or online.
            </p>

            <h4 className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "var(--cs-cyan)" }}>Get in Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "var(--cs-cyan)" }} />
                <a href={CONTACT_INFO.phoneHref} className="text-slate-200 hover:text-white" data-testid="footer-phone">{CONTACT_INFO.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "var(--cs-cyan)" }} />
                <a href={CONTACT_INFO.emailHref} className="text-slate-200 hover:text-white break-all" data-testid="footer-email">{CONTACT_INFO.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "var(--cs-cyan)" }} />
                <span className="text-slate-200">{CONTACT_INFO.location}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "var(--cs-cyan)" }}>Find Me</h4>
            <div className="rounded-2xl overflow-hidden border border-white/10 shadow-xl" data-testid="footer-map">
              <iframe
                title="Verna Carr Tarot — 15 Mill Rd Whitianga"
                src={CONTACT_INFO.mapEmbed}
                width="100%"
                height="280"
                style={{ border: 0, display: "block" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <p className="mt-3 text-xs" style={{ color: "#94A3B8" }}>
              <MapPin className="w-3 h-3 inline-block mr-1 -mt-0.5" />
              {CONTACT_INFO.address} — readings are by appointment.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs" style={{ color: "#94A3B8" }}>
          <p>© {new Date().getFullYear()} Verna Carr Tarot Readings. All rights reserved.</p>
          <p className="italic font-serif-display text-sm text-slate-200">"{BRAND_TAGLINE}"</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
